export const cnSimple = {
  About: '关于我们',
  // WhatWeDo: 'What We Do',
  LiveVideo: '录影片段',
  // Solutions: 'Solutions',
  // Construction: 'Construction',
  // Retail: 'Retail',
  // HealthCare: 'Health Care',
  // EventVenues: 'Event Venues',
  // Transportation: 'Transportation',
  // Hospitality: 'Hospitality',
  // Platforms: 'Platforms',
  Client: '客户',
  // HowItWorks: 'How it works',
  Team: '团队',
  Media: '媒体',
  Awards: '成就',
  Apple: 'Apple',
  Contacts: '联络',
  News: '新闻',
  // SmartVenues: 'Smart Venues',
  // SmartConstruction: 'Smart Construction',

  // home

  'home-head-black-1': '给所有企业的',
  'home-head-red-1': '人工智能',
  'home-head-black-2': '与',
  'home-head-red-2': '大数据平台',
  'home-head-small': '随赏科技有限公司提供市场领先的 AI 基础架构，可实现数据即时性，帮助决策者快速作出决策。 ',
  'home-contact-btn': '联络我们',
  'section-title-1': '室内定位',
  'section-sub-title-1': '室内场域导航，掌握人员动向，人员安全防护',
  'section-1-img-1-title': '工厂端解决方案',
  'section-1-img-1-p': '掌握生产人员位置，有效控管人员区域密集度，进而减少场内能源消耗。人员呼叫快速定位，紧急事故发生能快速掌握人员位置，增加抢救黄金时间。',
  'section-1-img-2-title': '销售',
  'section-1-img-2-p': '导引旅客航厦内部位置，快速解决多国旅客需求服务与登机闸门导引。快速协寻登机旅客位置，于App中主动通知旅客搭机服务，降低航班延飞等服务纠纷。',
  'section-1-img-3-title': '展馆端解决方案',
  'section-1-img-3-p': '展品介绍服务，馆内导引服务并能结合展品介绍服务，依据参观者位置主动动态介绍展品服务。',
  'section-title-2': '我们的优势',
  'section-2-row-1-title': '场域定位技术',
  'section-2-row-1-detail': 'UWD室内精准定位系统：<br/>10cm~30cm高精密度定位距离，快速迅速定位。支援无限制扩充装置数量。适用于长期建置，高稳定性。',
  'section-2-row-2-title': '装置定位技术',
  'section-2-row-2-detail': '装置定位方式採用两种方式：<br/>手机定位结合专属APP，适用于大型公共场域用户。蓝芽手环装置定位，适用于工厂或医院用户',
  'section-2-row-3-title': '客製化功能系统',
  'section-2-row-3-detail': '配合场域需求搭配人员定位系统，客製功能需求。搭配旅客登机提醒功能，孩童距离提醒功能。人员呼救与周边商家推广...等等功能。',
  // solutions
  'solutions-head-h1': 'Comprehensive <br/> multimedia solution',
  'solutions-head-small': 'From large TV walls to KIOSK multi-touch screens and the latest wave of somatosensory devices, according to different commercial marketing stages, we have developed corresponding application technologies to help customers create new-style business operation models and enhance brand market visibility, and Increase corporate profits and brand value.',
  'solutions-content-title': 'Through comprehensive multimedia interaction Solutions become a communication platform between brands and consumers',
  'solutions-item-1-title': 'Construction',
  'solutions-item-1-detail': 'Interactive maps and wayfinding for smart office',
  'solutions-item-2-title': 'RETAIL',
  'solutions-item-2-detail': 'Maps and wayfinding for shopping centers and retailers',
  'solutions-item-3-title': 'HEALTHCARE',
  'solutions-item-3-detail': 'Interactive maps and wayfinding for hospitals',
  'solutions-item-4-title': 'EVENT VENUES',
  'solutions-item-4-detail': 'Event maps and wayfinding for trade shows, conventions and festivals.',
  'solutions-item-5-title': 'TRANSPORTATION',
  'solutions-item-5-detail': 'Indoor maps and wayfinding for airports and train stations',
  'solutions-item-6-title': 'HOSPITALITY',
  'solutions-item-6-detail': 'Maps and wayfinding solution for hotels, cruise lines and theme parks.',

  // platforms
  'platforms-head-h1': 'Deploy new digital <br />services inside your <br />smart buildings',
  'platforms-head-small': 'A simple hit on the “Publish” button will allow you to share your map with everyone!',
  'platforms-item-1-title': 'Wayfinding',
  'platforms-item-1-detail': 'Mapwize has a Search Engine that allows users to locate any kind of resources on the map whether it is a meeting room or a printer.' +
    '<br /><br />' +
    'Mapwize provides a powerful Direction Engine to compute the best route towards your destination and can also optimize multi-destination itineraries. Reduced mobility users can select a dedicated mode to obtain suitable itineraries.',
  'platforms-item-2-title': 'CMS',
  'platforms-item-2-detail': `Mapwize uses outdoor global maps and adds indoor data to them. This way, our maps combine both indoor and outdoor services using the same tool.
    <br/><br/>
    All data not being of interest for everyone, Mapwize offers different Universes to display appropriate content in accordance with user roles (visitors, occupants, maintenance workers, security agents, etc.). Mapwize can manage an unlimited number of Universes per venue.
    <br/><br/>
    Mapwize has always been a multilingual platform with the ability to handle any language including Non-Europeans (Russian, Chinese, Arabic, etc.).`,
  'platforms-item-3-title': 'Dashboard',
  'platforms-item-3-detail': `Mapwize’s back-office, the Studio, is able to process the most common building file formats such as Autocad or GeoJSon. This way the overall floorplan import process is rapidly executed even by non-specialists.
    <br/><br/>
    Once existing floorplans are imported, the Studio provides all the necessary tools to add data and customize the maps. This includes but is not limited to: Universes, Points-of-Interest, Directions, Languages. Changes and updates are propagated in real-time on the platform.`,
  'platforms-item-4-title': 'Framework',
  'platforms-item-4-detail': `Mapwize works with any Indoor Positioning System (IPS) including but not limited to: Beacons, Wi-Fi, Li-Fi, Ultrasounds, Earth’s Magnetic field, Sensor fusion. Additionally, Mapwize provides a unique framework designed to combine multiple IPSs and select the most accurate system at anytime. Also, this framework enables advanced filters to increase position accuracy based on building topology.
    <br/><br/>
    This framework, called Indoor Positioning is available as an Open Source project under the MIT License.`,
  'platforms-item-5-title': 'Automation',
  'platforms-item-5-detail': `Mapwize is an open platform by design because we believe Indoor Mapping should be a core component to many third-party software applications. Accordingly, we also believe it is of the most importance to give developers a highly customizable mapping component.
    <br/><br/>
    Therefore, Mapwize comes with a fully interoperable Application Programming Interface (API) to permit server-side automation and multiple SDKs for iOS, Android and Javascript. This way, developers can easily embed Mapwize maps inside their own applications.
    <br/><br/>
    Mapwize API and SDKs are freely available on Github.`,
  'platforms-item-6-title': 'Security',
  'platforms-item-6-detail': `Security is a top concern here at Mapwize. Our maps are protected by strong access keys which are both customizable in scope (universes, floors, etc.) and duration.
    <br/><br/>
    Mapwize is hosted on the Microsoft Azure Cloud and is either available in SaaS mode (Multi-tenant server or private server) or on-premises.`,

  // how it works
  'howitworks-head-h1': 'How our service works',
  'howitworks-head-small': 'A seamless path for buildings Indoor mapping just became easy. super easy to integrate and our customers would tell you the same! We are a developer-friendly company committed to providing the most complete tools for those who create the best mobile and web applications.',
  'howitworks-item-1-title': '整合服務',
  'howitworks-item-1-detail': '協助增建客戶需求功能。',
  'howitworks-item-2-title': '客製化可視化介面',
  'howitworks-item-2-detail': '客製化可視化介面，包含生產數據、機台運轉狀況、庫存資料呈現、客製化需求頁面。便利使用端快速了解生產資訊內容。',
  'howitworks-item-3-title': '數據收集',
  'howitworks-item-3-detail': '提供機台生產數據資料擷取功能。透過PLC資料擷取盒，獲取機台內部生產數據。解決無法取得機台生產資訊問題。',
  'howitworks-item-4-title': '依據機台數據進行分析',
  'howitworks-item-4-detail': '依據機台數據進行分析，透過AI自主學習技術進行問題建模，進而改善生產問題，提升生產效能。解決生產中問題狀況，有效提升生產效能與減少庫料耗損。',

  // imdf
  'imdf-head-h1': 'Apple Indoor <br/> Positioning Technology',
  'imdf-head-small': `Compathnion provides zero-additional hardware solution using Any WiFi based on Wherami technology. In iOS, we have cooperation with Apple ecosystem.
    <br/>
    Apple introduced indoor positioning technology for iOS on Any WiFi, which is accurate to about 3-5 metres. They have developed a new data model for positioning in iOS apps called IMDF.
    <br/>
    Compathnion is the 1st Large Scale Zero-Additional Hardware LBS Solution for both Android and iOS in the Greater Bay Area. And we have deployed the iOS solution in many venues.`,
  'imdf-item-1-title': '如何启用iOS定位？',
  'imdf-item-1-detail': `我们拥有多年提供iOS定位服务的丰富经验，属于全港少数获Apple认可的室内定位服务供应商。您可以跟随以下步骤设定Apple室内导航服务：
    <br/><br/>
    <p>1. 于Apple Map Connect登记公司帐号及地址 (https://register.apple.com/indoor)</p>
    <p>2. 建立IMDF并上传至Apple Map Connect</p>
    <p>3. 获得许可后，进行实地测量</p>
    <p>4. 上传实地数据</p>
    <br/><br/>
    我们提供一站式咨询及安装服务，为您完成IMDF设置、地图实地绘制、App设计以及维护工作。 `,
  'section-2-title': '为何要启动iOS室内定位？ ',
  'imdf-horizontal-item-1-title': '完善的iOS支援',
  'imdf-horizontal-item-1-content': `室内和室外定位的无缝过渡。<br/>
    电池的优化使用：iOS 核心位置服务针对iOS设备进行了优化，并在定位和导航过程中将电池消耗降至最低。`,
  'imdf-horizontal-item-2-title': '强大的发展网络',
  'imdf-horizontal-item-2-content': `作为场地拥有者，Apple 室内定位一旦在您的场地激活了，它就会给所有 iOS 平台应用程序开发员带来好处。<br/>
    在应用程序方面，在 iOS 上启用了任何室内定位，室内定位的覆盖範围就会持续扩大。`,
  'imdf-horizontal-item-3-title': '城市化 <br/> 定位服务',
  'imdf-horizontal-item-3-content': 'Apple 室内定位旨在支持全市範围内的应用程序。 该服务不限於单一场所，室内定位服务已在城市级别甚至跨城市进行了优化。',

  // Contact
  'contact-section-1-title': '联络我们',
  'contact-title': '随赏科技有限公司',
  'contact-content-address': `
    香港新界沙田,
    <br />
    香港科学园,
    <br />
    12W, 6楼, 617室`,
  'contact-content-info': `
    电邮:  <br />
    <a href="mailto: info@compathnion.com">info@compathnion.com</a> <br />
    电话: <br />
    <a href="tel:+852-3465-5803">(852) 3465 5803</a><br/>
    网站: <br/>
    <a href="https://compathnion.com">https://compathnion.com</a>`,

  // Construction
  'construction-title': 'Construction',
  'construction-detail': 'Customized visual interface, including production data, machine operating status, inventory data display and customized demand pages. Users can easily and quickly understand the content of production information.',
  'construction-item-1-title': '工業數位整合服務',
  'construction-item-1-detail': `
    工業4.0著重在將現有的工業相關的技術、銷售與產品體驗統合起來，是建立具有適應性、資源效率和人因工程學的智慧型工廠，我們將提供工廠數位化所需要的整合性技術服務。
    <br/><br/>
    MES：工廠生產履歷資訊建置協助服務
    <br/><br/>
    SCADA：環境監測與生產資訊可視化介面呈現應用服務
    <br/><br/>
    PLC：生產機台數據收集與自動化控制系統
    <br/><br/>
    AI深度學習技術：大數據深度分析與改善生產曲線服務系統。
  `,
  'construction-item-2-title': '整合服務架構',
  'construction-item-2-detail': `
    MES顧問管理，可視化建置服務，機台生產數據收集，AI深度學習技術
    <br/><br/>
    透過MES 系統架構，整合生產時所產生的數據資料，圖表化呈現顯示
    <br/><br/>
    透過我們的PLC資料擷取盒，主動獲取機台生產參數與數據資料，穩定傳送到MES資料庫中進行記錄。
    透過MES系統判斷彙整後，提供給予SCADA可視化介面進行數據資料呈現。
    <br/><br/>
    機台存取的數據資料，進入我們的AI深度學習技術，依據大數據分析後進而調整生產控制，有效提升生產效能。
  `,

  // Our Client
  'our-client-section-1-title': '合作客户',

  // our team
  'our-team-title': '团队',
  'our-teammate-1-name': '陈双幸教授',
  'our-teammate-1-position': '创办人',
  'our-teammate-1-description': `
  Dr. S.-H. Gary Chan is currently a Professor in the Department of Computer Science and Engineering, The Hong Kong University of Science and Technology (HKUST).  He is also an Affiliate Professor in Innovation, Policy and Entrepreneurship Thrust of HKUST(GZ), Chair of the Committee on Entrepreneurship Education Program at HKUST, and Board Director of Hong Kong Logistics and Supply Chain MultiTech R&D Center (LSCM).  He received his MSE and PhD degrees in Electrical Engineering with a Minor in Business Administration from Stanford University (Stanford, CA).  He obtained his BSE degree (highest honor) in Electrical Engineering from Princeton University (Princeton, NJ), with certificates in Applied and Computational Mathematics, Engineering Physics, and Engineering and Management Systems.
  <br /><br />
  Professor Chan has co-founded and transferred his research results to several startups. Due to their innovations and commercial impacts, his startups and research projects have received local and international accolades. Notably, he received Hong Kong Chief Executive's Commendation for Community Service for ''outstanding contribution to the fight against COVID-19" in 2020.  He is the recipient of Google Mobile 2014 Award and Silver Award of Boeing Research and Technology. He is a Chartered Fellow of The Chartered Institute of Logistics and Transport (FCILT).
  `,
  'our-teammate-2-name': '陈智铨先生',
  'our-teammate-2-position': '董事兼首席执行官',
  'our-teammate-2-description': `
  从大学时开始，他一直相信数据技术未来对每个人的影响会超过互联网。
  <br /><br />
  他以一级荣誉生毕业于香港科技大学计算机科学工程专业，一直成绩斐然，并且是加州大学洛杉矶分校的交换学者。
  <br /><br />
  他是物联网、边缘计算和开源软件开发领域公认的专家。他应邀在专业活动上发言，并担任物联网董事会成员。
  `,

  // news
  'news-section-title-1': '新闻',

  // Awards
  'awards-section-title-1': '我们的成就',

  // live video
  'live-video-head-h1': '示范影片',
  'live-video-head-small': 'Top technology for the construction.',
  'live-video-section-title-1': '示范影片',

  // footer
  'footer-title': '联络我们',
  'contact-email': '电邮: info@sagadigits.com',
  'contact-tel': '电话: (852) 3465 5803',
  'contact-address': '地址: 香港新界沙田,香港科学园,12W, 6楼, 617室',
  'footer-copyright': 'Compathnion, A Member of SagaDigits Group © 2023.'
}
